import Request from 'commons/libs/requests';
import { isAxiosError } from 'axios';
import { User } from './userTypes';

export async function fetchUser() {
  return (await Request.get('/users/user/')).data;
}
export async function updateUser(user: User) {
  return (await Request.patch(`/api-patients/patients/${user.id}/`, user)).data;
}
export async function updateUserCycle(patientID: string, state: string) {
  return (
    await Request.patch(`/api-patients/patients/${patientID}/cycle/`, {
      state,
    })
  ).data;
}

export async function setUserTimer(patientID: string) {
  return (
    await Request.post(`/api-patients/patients/${patientID}/set_timer_end/`)
  ).data;
}

export async function requestMailOtp(email: string) {
  try {
    return (
      await Request.post(`/api-patients/patients/request_email/`, { email })
    ).data;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 429) {
      return {
        status: 429,
        availableIn: error.response!.data.availableIn,
      };
    }
    throw error;
  }
}

export async function confirmMailOtp(email: string, otp: string) {
  try {
    return (
      await Request.post(`/api-patients/patients/confirm_email/`, {
        email,
        otp,
      })
    ).data;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 409) {
      return {
        status: 409,
      };
    }
    throw error;
  }
}

export async function requestPhoneOtp(phone: string) {
  try {
    return (
      await Request.post(`/api-patients/patients/request_phone/`, { phone })
    ).data;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 429) {
      return {
        status: 429,
        availableIn: error.response!.data.availableIn,
      };
    }
    throw error;
  }
}

export async function confirmPhoneOtp(phone: string, otp: string) {
  try {
    return (
      await Request.post(`/api-patients/patients/confirm_phone/`, {
        phone,
        otp,
      })
    ).data;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 409) {
      return {
        status: 409,
      };
    }
    throw error;
  }
}

export async function getHubspotUser(
  email: string,
  firstName: string,
  lastName: string,
) {
  const response = await Request.post('/api-patients/patients/conversation/', {
    email,
    firstName,
    lastName,
  });
  return response.data.token;
}

export async function fetchServices() {
  return (await Request.get('/api/services/')).data;
}
